import consumer from "../consumer";
import {Subscription} from "@rails/actioncable";

export class VotingRoundReportChannelSubscription {
  public subscription: Subscription;
  private readonly votingRoundReportId: number;

  constructor(votingRoundReportId: number, { received, connected = undefined, disconnected = undefined }) {
    this.votingRoundReportId = votingRoundReportId;
    this.subscription = consumer.subscriptions.create(
      {
        channel: "E2E::VotingRoundReportChannel",
        id: this.votingRoundReportId,
      },
      {
        received,
        connected,
        disconnected,
      }
    );
  }

  unsubscribe() {
    this.subscription.unsubscribe();
  }
}